<mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
  <mat-label i18n>Радиус</mat-label>
  <input
    data-testid="rInput"
    type="number"
    [ngModel]="_value"
    #V="ngModel"
    (ngModelChange)="V.invalid ? null : valueChange.emit($event)"
    matInput
    required
    [range]="[min, max]"
    number
    (click)="$any($event.target).select()"
    [disabled]="!editable" />
  <div i18n matSuffix>мм</div>
  <mat-error *ngIf="V.invalid"> ≥{{ min }}, ≤{{ max }} </mat-error>
</mat-form-field>
